// Shared interface for related items (properties, uses, categories, safety notes)
export interface RelatedItem {
  id: string;
  name: string;
  description?: string;
  icon?: string;
  sortOrder?: number;
}

// Usage and safety indicators shared across all product types
export type AudienceSafety = "safe" | "unsafe" | null;

export interface UsageSafetyIndicators {
  canAromatic?: boolean | null;
  canTopical?: boolean | null;
  canInternal?: boolean | null;
  isPhotosensitive?: boolean | null;
  requiresDilution?: boolean | null;
  safetyPregnant?: AudienceSafety;
  safetyChildren?: AudienceSafety;
  safetyBabies?: AudienceSafety;
  safetyPets?: AudienceSafety;
}

// Helper to get the display name from a RelatedItem or string (for backward compatibility)
export function getItemName(item: RelatedItem | string): string {
  return typeof item === "string" ? item : item.name;
}

// Helper to map DB row to UsageSafetyIndicators
export function mapUsageSafetyFromDB(db: any): UsageSafetyIndicators {
  return {
    canAromatic: db.can_aromatic ?? null,
    canTopical: db.can_topical ?? null,
    canInternal: db.can_internal ?? null,
    isPhotosensitive: db.is_photosensitive ?? null,
    requiresDilution: db.requires_dilution ?? null,
    safetyPregnant: db.safety_pregnant ?? null,
    safetyChildren: db.safety_children ?? null,
    safetyBabies: db.safety_babies ?? null,
    safetyPets: db.safety_pets ?? null,
  };
}
